export default {
  softSaleStockItemAudits: [],
  softSaleStockItemAudit: undefined,
};
